import { c as _c } from "react/compiler-runtime";
import { IcoBuilding16, IcoMapPinDefault, IcoMapPinSelected } from '@onefootprint/icons';
import { useTheme } from 'next-themes';
export type MapMarkerProps = {
  id: string;
  onClick: () => void;
  latitude: number;
  longitude: number;
  isSelected: boolean;
};
const MapMarker = t0 => {
  const $ = _c(11);
  const {
    id,
    onClick,
    latitude,
    longitude,
    isSelected
  } = t0;
  const theme = useTheme();
  const isDark = theme.theme === "dark";
  const iconColorDefault = isDark ? "tertiary" : "primary";
  const iconColorSelected = isDark ? "primary" : "quinary";
  let t1;
  if ($[0] !== isSelected) {
    t1 = <div className="flex items-center justify-center [&>svg>path]:drop-shadow-lg">{isSelected ? <IcoMapPinSelected /> : <IcoMapPinDefault />}</div>;
    $[0] = isSelected;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = isSelected ? iconColorSelected : iconColorDefault;
  let t3;
  if ($[2] !== t2) {
    t3 = <div className="flex justify-center items-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-[90%]"><IcoBuilding16 color={t2} /></div>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== id || $[5] !== latitude || $[6] !== longitude || $[7] !== onClick || $[8] !== t1 || $[9] !== t3) {
    t4 = <button id={id} className="relative flex items-center justify-center cursor-pointer" onClick={onClick} data-latitude={latitude} data-longitude={longitude} type="button">{t1}{t3}</button>;
    $[4] = id;
    $[5] = latitude;
    $[6] = longitude;
    $[7] = onClick;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default MapMarker;